import '../../css/table.css';
import React from 'react';
import Layout from '../Shared/Layout';
import {
    Container,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import styled from "styled-components";
import {Trans} from "../utils/i18n";

const Wrapper = styled.div`
`;

export default function DropoffPoints({carrier, dropoffs}) {
    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <h1>{carrier.name} <Trans i18nKey="dropoffs_points">Drop Off Points</Trans></h1>
                    <TableContainer>
                        <Table size="large"
                               aria-label={<Trans i18nKey="queueDetail.collapsibleTable">collapsible table</Trans>}>
                            <TableHead>
                                <TableRow>
                                    <TableCell><Trans i18nKey="dropoffs_points.region">Region</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.province">Province</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.company_name">Company
                                        Name</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.address">Address</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.postal_code">Postal
                                        Code</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.town">Town</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.telephone">Telephone</Trans></TableCell>
                                    <TableCell><Trans i18nKey="dropoffs_points.email">Email</Trans></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dropoffs.map((dropoff, i) => {
                                    return <TableRow key={`dropoff-points-table-row-${i}`}>
                                        <TableCell>{dropoff?.region}</TableCell>
                                        <TableCell>{dropoff?.province}</TableCell>
                                        <TableCell>{dropoff?.company_name}</TableCell>
                                        <TableCell>{dropoff?.street}</TableCell>
                                        <TableCell>{dropoff?.zip}</TableCell>
                                        <TableCell>{dropoff?.city}</TableCell>
                                        <TableCell>{dropoff?.phone}</TableCell>
                                        <TableCell>{dropoff?.email}</TableCell>
                                    </TableRow>
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </Grid>
            </Container>
        </Wrapper>
    )
}

DropoffPoints.layout = page => <Layout children={page}/>;
